import { SearchIcon } from "../../Icon"

type AppProps = {
  placeHolder: string;
  handleSearch: (e: any) => void;
  value?: string;
}

const SearchBar = ({ placeHolder, handleSearch, value }: AppProps) => {
  return (
    <div className="row">
      <div className="col-md-8"></div>
      <div className="col-md-4">
        <span style={{ position: "absolute", top: "8px", left: "25px" }}>
          <SearchIcon />
        </span>
        <input
          className="form-control"
          type="text"
          placeholder={placeHolder}
          onChange={handleSearch}
          style={{ paddingLeft: "35px" }}
          value={value}
        />
      </div>
    </div>
  )
};

export default SearchBar;